module.exports = __webpack_public_path__ + "img/ble-old.5ba6673a.png";